import { Injectable } from '@angular/core';
import {HttpContextToken} from "@angular/common/http";
import {Subject} from "rxjs";

/** Фоновий запит (довідковий розрахунок): не показує повноекранний лоадер. Інакше запит,
 *  що йде слідом за завантаженням сторінки, вдруге затемнював уже показану сторінку (картка #388). */
export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  public clearRequest: boolean = false;
  public hiddenChange: Subject<any> = new Subject<any>();
  private cancelPendingRequests$ = new Subject<void>();

  constructor() { }

  public cancelPendingRequests() {
    return this.cancelPendingRequests$.next();
  }

  public onCancelPendingRequests() {
    return this.cancelPendingRequests$.asObservable();
  }
}
